import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, TextField, Button, Typography, Alert } from '@mui/material';
import { login } from '../services/api';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await login(form);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/dashboard');
    } catch {
      setError('E-posta veya şifre hatalı');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
      <Card sx={{ p: 4, width: 380 }}>
        <Typography variant="h5" fontWeight={700} textAlign="center" mb={1}>📦 Miksan Plastik</Typography>
        <Typography variant="body2" textAlign="center" color="text.secondary" mb={3}>Admin Paneli</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField fullWidth label="E-posta" type="email" value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })} sx={{ mb: 2 }} required />
          <TextField fullWidth label="Şifre" type="password" value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })} sx={{ mb: 3 }} required />
          <Button fullWidth variant="contained" type="submit" disabled={loading}
            sx={{ bgcolor: '#1a237e', py: 1.5 }}>
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </Button>
        </form>
      </Card>
    </Box>
  );
}
